module.exports = require("/Users/alfredotang/Desktop/91app-tech-blog/.gatsby/gatsby-browser.tsx");